module.exports = __webpack_public_path__ + "media/images/mobile/city_img/g2-d6b44b427ba3174d0205cdfbc2cc136b.png";